class ViewStackRegion extends Backbone.Marionette.Region {
    constructor(...args) {
        super(...args);
        this.showOnStack = this.showOnStack.bind(this);
        this.onViewClose = this.onViewClose.bind(this);
    }

    initialize() {
        this._viewStack = [];
    }

    _showNext() {
        this.dispatch("viewstack:next", this);
        // Prevent an endless loop
        if (this.currentView != null) {
            this.stopListening(this.currentView);
        }
        const view = this._viewStack[this._viewStack.length - 1]();
        try {
            this.show(view);
            this.listenTo(view, "close", this.onViewClose);
        } catch (e) {
            throw new Error(`Couldn't show view: ${e}`);
        } finally {
            this.dispatch("viewstack:ready", this);
        }
    }

    // The viewFn should return a view, not be a view
    showOnStack(viewFn) {
        if (typeof viewFn !== "function") {
            throw new Error("Non-function viewFn passed to ViewStackRegion.showOnStack");
        }
        this._viewStack.push(viewFn);
        this.trigger("region:push", viewFn);
        this._showNext();
    }

    onViewClose() {
        if (this.currentView != null) {
            this.stopListening(this.currentView);
        }

        this.trigger("region:pop", this._viewStack.pop());
        if (this._viewStack.length > 0) {
            this._showNext();
        } else {
            this.trigger("region:close");
            this.close();
        }
    }
}

export default ViewStackRegion;



// WEBPACK FOOTER //
// ./app/lib/viewstackregion/ViewStackRegion.js